import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

import './PeriodicControl.scss';

const PeriodicControlSkeleton: React.FC = () => {
    return (
        <div className="periodic-control__skeleton-wrapper">
            <div className="periodic-control-icon-title-skeleton">
                <DarkSkeleton height={300} width="80%" />
            </div>
            <div>
                <DarkSkeleton height={60} width="100%" />
            </div>
            <div>
                <DarkSkeleton height={60} width="100%" />
            </div>
        </div>
    );
};

export default PeriodicControlSkeleton;
